import { render, staticRenderFns } from "./CommonWritePaResult.vue?vue&type=template&id=4a04c612&scoped=true"
import script from "./CommonWritePaResult.vue?vue&type=script&lang=js"
export * from "./CommonWritePaResult.vue?vue&type=script&lang=js"
import style0 from "./CommonWritePaResult.vue?vue&type=style&index=0&id=4a04c612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a04c612",
  null
  
)

export default component.exports